import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/routes';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';
import { errorInterceptor } from './app/shared/interceptors/http-errors.interceptor';
import localeCO from '@angular/common/locales/es-CO';
import { registerLocaleData } from '@angular/common';
import { provideIcons } from '@ng-icons/core';
import { ICONS } from './icons';

registerLocaleData(localeCO);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(BrowserModule),
    provideRouter(APP_ROUTES),
    provideIcons(ICONS),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    { provide: LOCALE_ID, useValue: 'es-CO' },
  ],
}).catch((err) => console.error(err));
